export class SettingKeys {
  public static keyUsePreview = 'list-preview';
  public static keyWebDokuShowDescription = 'webdoku-showdescription';
  public static keyDocInNewTab = 'doc-newtab';
  public static keyTreeInNewTab = 'tree-newtab';
  public static keyToolBarPosition = 'toolbar-position';
  public static keySideBarCollapse = 'sidebar-collapse';
  public static keyDocumentToolbar = 'document-toolbar';
  public static keyTextTruncation = 'text-truncation';
  public static keyShowTooltips = 'show-tooltips';
  public static keyTheme = 'theme';
  public static keyLanguage = 'languages';
  public static keyPdfEditor = 'pdf-editor';
  public static keyPdfEditingDisabled = 'pdf-editing-disable';
  public static keyPdfPrintEnabled = 'pdf-print-enabled';
  public static keyPdfDownloadEnabled = 'pdf-download-enabled';
  public static keySearchButtonInHeader = 'search-in-header';
  public static keySearchDefaultMode = 'search-default';
  public static keySearchWildCard = 'search-wildcard';
  public static keyDefaultHelpVisible = 'help-showdefault';
  public static keyCustomHelpFile = 'help-customurl';
  public static keyCustomHelpTitle = 'help-customtext';
  public static keyPWAEnabled = 'pwa-enabled';
}
